<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='文章管理' subPath='栏目列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="2">
          <el-button type="primary" @click="showAddDialog">添加栏目</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="groupList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
      <el-table-column prop="title" label="名称" align="center"></el-table-column>
      <el-table-column prop="icon_url" label="图标" align="center">
        <template slot-scope="scope">
          <el-image :src="scope.row.icon_url+'?imageView2/0/w/50'"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="sort_num" label="排序" align="center"></el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          {{scope.row.create_time | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <handpick-group-add
      :visible="addDialogAvaible"
      :id="currentId"
      @add="addGroup"
      @update="updateGroup"
      @closeDialog="closeAddDialog">
    </handpick-group-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import handpickGroupAddVue from './handpickGroupAdd.vue'
export default {
  name: 'handpick_group_list',
  components: {
    'bread-crumb': BreadCrumb,
    'handpick-group-add': handpickGroupAddVue
  },
  data () {
    return {
      groupList: [],
      currentId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        page: 1,
        count: 10
      },
      addDialogAvaible: false
    }
  },
  created () {
    this.getGroupList()
  },
  methods: {
    async getGroupList () {
      const res = await this.$http.get('/admin/handpick_group/list', this.param)
      if (res.code === 0) {
        this.groupList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getGroupList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getGroupList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/handpick_group/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getGroupList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    async addGroup (data) {
      const res = await this.$http.post('/admin/handpick_group/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getGroupList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateGroup (id, data) {
      const res = await this.$http.post('/admin/handpick_group/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getGroupList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
  .el-image {
    width: 50px;
  }
</style>
